import type { IActiveElectionResponse } from '../../../interface/state/ICandidate';
import { candidateType } from '../../types';
import { createAPI, deleteByIdAPI, getAPI, getByIdAPI, updateAPI } from '../api-utils';

interface ICreateCandidtate {
	electionId: number;
	userId: number;
}

export const create = createAPI<undefined, ICreateCandidtate>({
	actionType: candidateType.create,
	url: '/api/v1/Candidate',
});

export const get = getAPI({
	actionType: candidateType.get,
	url: '/api/v1/Candidate',
	type: 'core',
});

export const getByID = getByIdAPI({
	actionType: candidateType.getByID,
	url: '/api/v1/Candidate',
});

interface IUpdateCandidate {
	id: number;
	electionId: number;
	firstName: string;
	middleName: string;
	lastName: string;
	alias: string;
	partyId: number;
}

export const update = updateAPI<undefined, IUpdateCandidate>({
	actionType: candidateType.update,
	url: '/api/v1/Candidate/update',
});

export const deleteById = deleteByIdAPI({
	actionType: candidateType.deleteById,
	url: '/api/v1/Candidate/delete',
});

export const getCandidateElection = getByIdAPI({
	actionType: candidateType.getCandidateElection,
	url: '/api/v1/Candidate/get-election',
});

export const getActiveElections = getByIdAPI<IActiveElectionResponse>({
	actionType: candidateType.getActiveElections,
	url: '/api/v1/Candidate/get-active-elections',
});
